import { FC, ReactNode, ElementType } from 'react';

interface SectionWrapperProps {
  children: ReactNode;
  bgColor?: string;
  className?: string;
  as?: ElementType;
  id?: string;
  fullWidth?: boolean;
}

const SectionWrapper: FC<SectionWrapperProps> = ({
  children,
  bgColor = 'bg-white dark:bg-zinc-900',
  className = '',
  as: Component = 'section',
  id,
  fullWidth = false,
}) => {
  return (
    <Component id={id} className={`${bgColor} ${className}`}>
      {/* ✅ FIXED: Proper responsive padding + wider container */}
      <div className="w-full py-16 px-4 sm:px-6 lg:px-8">
        <div className={fullWidth ? 'w-full' : 'max-w-7xl mx-auto'}>
          {children}
        </div>
      </div>
    </Component>
  );
};

export default SectionWrapper;
